// 環境変数デバッグ（必要時のみコメント解除）
// console.log('[CONFIG] Environment:', process.env.NODE_ENV, process.env.REACT_APP_NODE_ENV);
// console.log('[CONFIG] API_KEY exists:', !!process.env.REACT_APP_API_KEY);

if (process.env.NODE_ENV === 'production') {
  //환경변수에 값을 준비
  module.exports = require('./prod');
  // console.log('[CONFIG] prod.js読み込む！');
} else if (process.env.REACT_APP_NODE_ENV === 'staging') {
  module.exports = require('./stag');
  // console.log('[CONFIG] stag.js読み込む！');
} else {
  module.exports = require('./dev');
  // console.log('[CONFIG] dev.js読み込む！');
}
